import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  TextField,
  Box,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function CategoryFormDialog({
  open,
  onClose,
  onSubmit,
  initialData,
  loading,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [name, setName] = useState("");
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (initialData) {
      setName(initialData.name || "");
      setActive(initialData.active ?? true);
    } else {
      setName("");
      setActive(true);
    }
  }, [initialData, open]);

  const handleSave = () => {
    onSubmit({ name: name.trim(), active });
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: "18px",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          fontWeight: 700,
          fontSize: "1.05rem",
        }}
      >
        {initialData ? "Editar categoría" : "Nueva categoría"}
      </DialogTitle>

      <DialogContent sx={{ pt: 2.2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.4 }}>
          <TextField
            autoFocus
            fullWidth
            label="Nombre de la categoría"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mt: 3 }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
              />
            }
            label="Categoría activa"
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2.4,
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleSave}
          variant="contained"
          disabled={loading || !name.trim()}
        >
          {loading
            ? "Guardando..."
            : initialData
            ? "Actualizar"
            : "Crear"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}